export default __webpack_public_path__ + "static/media/gallery_03.8417b447.jpg";